/**
 * The daily cap: a number of SMS a day, or "No limit" (the switch turns
 * destructive — only the stop-loss and Kill then stop a day), with today's
 * spend against it. Every generator SMS sent today counts, a person's too.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { Switch } from '@/components/ui';

import { NumberField } from './SettingsBlock';

const n = (v: number) => v.toLocaleString('en-US');

export const CapField: FC<{
  noCap: boolean;
  cap: number;
  sentSms: number | null;
  /** The hold sentence a capped draft carries — whose cap it is. */
  holdNote: string;
  onChange: (patch: { noCap?: boolean; cap?: number }) => void;
}> = ({ noCap, cap, sentSms, holdNote, onChange }) => {
  const pct = !noCap && cap > 0 && sentSms !== null ? Math.min(100, (sentSms / cap) * 100) : 0;
  return (
    <div className="flex flex-col gap-2">
      <div className="flex flex-wrap items-center gap-3 text-sm">
        <label className="inline-flex items-center gap-2">
          <Switch checked={noCap} onCheckedChange={(v) => onChange({ noCap: v })} aria-label="No limit" className={noCap ? 'data-[state=checked]:bg-destructive' : ''} />
          <span className={noCap ? 'font-semibold text-destructive' : 'text-muted-foreground'}>No limit</span>
        </label>
        <NumberField value={cap} onChange={(v) => onChange({ cap: v })} label="Daily cap (SMS)" width="w-32" disabled={noCap} />
        <span className="text-xs text-muted-foreground">SMS a day</span>
      </div>
      {noCap ? (
        <p className="text-xs text-destructive">No ceiling — only the stop-loss and Kill stop a day.</p>
      ) : (
        <div className="flex flex-col gap-1.5">
          {sentSms !== null ? (
            <div className="h-2 w-full max-w-sm overflow-hidden rounded-full bg-muted">
              <div className="h-full rounded-full bg-primary transition-[width] duration-700 ease-out" style={{ width: `${pct}%` }} />
            </div>
          ) : null}
          <p className="text-xs text-muted-foreground">
            {sentSms !== null ? <><span className="font-mono text-foreground">{n(sentSms)}</span> of {n(cap)} sent today — </> : null}
            at the cap the rest waits, marked “{holdNote}”.
          </p>
        </div>
      )}
    </div>
  );
};
